module.exports = function forEach(arr, fn) {
  for (var i = 0; i < arr.length; i++) {
    fn(i, arr[i]);
  }
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/chickencurry/lib/forEach.js
// module id = 427
// module chunks = 3